import { render } from "./AlertBox.vue?vue&type=template&id=62f93cc3&scoped=true&ts=true"
import script from "./AlertBox.vue?vue&type=script&lang=ts"
export * from "./AlertBox.vue?vue&type=script&lang=ts"

import "./AlertBox.vue?vue&type=style&index=0&id=62f93cc3&lang=scss&scoped=true"

import exportComponent from "/builds/atx/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62f93cc3"]])

export default __exports__